import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { MaphelperService } from "src/app/app-analysis-module/maphelper.service";
import { CommonServiceService } from "src/app/common-module/common-service.service";
import { IsochroneService } from "src/app/isochrone-module/isochrone.service";
import { AuthService } from "src/app/_services";
import { AssignUserToolComponent } from "../assign-user-tool/assign-user-tool.component";
import { AssignUserService } from "../assign-user.service"
import { MapComponent } from "projects/lib-map-common/src/lib/map/map.component";
import { LassoToolsComponent } from "projects/lib-map-common/src/lib/lasso-tool/lasso-tools.component";
import { CommonPolyNavComponent } from "projects/lib-map-common/src/lib/common-poly-nav/common-poly-nav.component";

@Component({
  selector: 'app-assign-user-home',
  templateUrl: './assign-user-home.component.html',
  styleUrls: ['./assign-user-home.component.css']
})
export class AssignUserHomeComponent implements OnInit {
  hideMapDrawTool: boolean = false;
  @ViewChild(CommonPolyNavComponent, { static: true })
  commonPolyNav: CommonPolyNavComponent;
  skipButton: boolean = false;
  canShowSlider = true;
  showNote: boolean = false;
  geometry = [];
  loader: boolean = false;
  enableDisableRadio;
  layerId;
  empForm: UntypedFormGroup;
  mapCarto: any;
  layerToBeAdded;
  exactWith: any;
  mapid;
  matStepStepper = false;
  mapLayers: any;
  draw: any;
  canDrawMultiplePolygon = true;
  @Output() drawDataEmit = new EventEmitter<any>();
  @ViewChild("stepper") stepper: MatStepper;
  @ViewChild(MapComponent, { static: true }) mapComponent: MapComponent;
  @ViewChild(AssignUserToolComponent) AssignUserTool: AssignUserToolComponent;
  @ViewChild(LassoToolsComponent) lassoToolsComponent: LassoToolsComponent;

  counter = 0;
  isFirst = false;
  multiplePolygonArray: any = [];
  Id: any;
  geojson: any;
  layerData;
  firstLayerSelected
  SelectedModel
  layer_details: any;
  layerType: any;
  attributData;
  obj;
  isNewLayerCreated: boolean;
  isLoggedIn;
  SubUserList
  IsLoader = false

  AddMore:boolean = true
  visible_one:boolean = true

  constructor(
    private authService: AuthService,
    private _isochroneService: IsochroneService,
    private router: Router,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private commonService: CommonServiceService,
    private AssignUserService: AssignUserService,
    private mapHelperService: MaphelperService) {

    this.mapid = this.route.snapshot.paramMap.get("map_id");
    this.layerId = this.route.snapshot.paramMap.get("done");
    this.commonService.EnableDrawGLStyle.next(false);

  }



  SubUsersStyle:any =null
  ngOnInit() {
    this._isochroneService.initializeMapCursorPopUp();
    this.UserList()
    this.getAssignedUsersList()
    this._isochroneService.EmitAllUsersData.subscribe(data=>{
      if(data){
        this.SubUsersStyle = data
      }
    })

  }


  stepperAddPoint: MatStepper;
  @ViewChild('stepperAddPoint') set content3(content3: MatStepper) {
    if (content3) {
      this.stepperAddPoint = content3;
    }
  }



  ngAfterViewInit(): void {
    this.logIn();

    if (!this.isLoggedIn) {
      this.router.navigate([`polygon`]);
    }
    this.mapCarto.on("draw.create", (e) => {

      if (this.hideMapDrawTool) {
        console.warn(e);
        let Features = {
          type: "Feature",
          properties: { id: e.features[0].id },
          geometry: {
            type: "POLYGON",
            coordinates: e.features[0].geometry.coordinates,
          },
          // form_data: this.layerValues.form_data
          form_data: this.layerData.form_data,
        };

        this.geometry.push(Features);
        this.canDrawMultiplePolygon = true;
        this.geometry.forEach((m, index) => {
          if (e.features[0].id == m.properties.id) {
            console.warn(this.geometry[index]);
            // this.commonPolyNav.showSlider(this.geometry[index]);
          }
        });

        this.counter++;
      }

    });



  }


  UserList() {
    this.AssignUserService.getSubUserList().subscribe(data => {
      console.log(data)
      if (data.data.length > 0) {
        this.SubUserList = data.data
      } else {
        // this.showErrorMessage2 = "user_not_found"
      }
    })
  }



  mapCartoEmit(mapCarto) {
    this.mapCarto = mapCarto;
  }

  emitexactwith(exactWith) {
    this.exactWith = exactWith;
  }

  styleemit(styleDetails) {
    if (styleDetails) {
      this.mapComponent.setStyleDetailsInMapLayers(this.layerId, styleDetails);
      this.mapComponent.TurnOffAndOnLayer(this.layerId);
    }
  }

  getMapLayers(mapLayers) {

    this.mapLayers = mapLayers;
    if (this.mapid && this.layerId) {
    }
  }

  getDraw(draw) {
    this.draw = draw;
  }

  multiplePolygon: boolean;
  drawPolygon() {
    this.commonPolyNav.closeShowInfo();
    this.canDrawMultiplePolygon = false;
    this.draw.changeMode("draw_polygon");
    this.drawStatus(this.draw);
  }


  drawStatus(draw) {
    console.warn(draw.getAll());
  }


  cordinates: any = false;
  RecivedCoordinates(e) {
    this.cordinates = e;
    console.log(this.cordinates);

    if (!this.cordinates) {
      return
    }

    if (this.MainToolModel == "draw_shape" && this.cordinates) {
      // this.AssignUserTool.FeatureHighlightedByLasso(this.cordinates)
    }

    else if (this.MainToolModel == "create_polygon") {

    }

    this.geometry.forEach((m, index) => {
      e.features.forEach((l, index1) => {
        if (m.properties.id == l.id) {
          this.geometry[index].geometry.coordinates = l.geometry.coordinates;
        }
      });
    });

  }

  // DeleteLasso
  DeleteLassoToolData() {
    this.draw.deleteAll()
    this.mapHelperService.MultiSelectFeature = false
    this.mapHelperService.GidCollection = []
    this.mapHelperService.ListenMapPopup.next(true)
  }

  LassoReset(event) {
    if (event) {
      this.DeleteLassoToolData()
    }
  }


  addSkipButton() {
    this.skipButton = true;
  }


  mapIdEmit(data) {
    this.mapid = data;
  }



  logIn() {
    this.authService.isLoggedIn.subscribe((data) => {
      this.isLoggedIn = this.authService.isAuthenticated();
    });
  }


  showInfo(event) {
    this.mapComponent.showInfo.close()
  }

  addLayerOnMapLayer(event) {
    this.mapComponent.addLayerOnMapLayer(event, 0)
  }


  setStyleDetailsInMap(event) {
    this.mapComponent.setStyleDetailsInMapLayers(event.layerid, event.finalSubuserStyle)
  }

  TurnOffAndOnLayer(event) {
    this.mapComponent.TurnOffAndOnLayer(event)
  }

  RecivedSelectedLayer(event) {
    this.firstLayerSelected = event
  }

  SelectedModelEmit(event) {
    this.SelectedModel = event
  }

  MainToolModel = "all_map"

  getAddDataType(value) {
    this.MainToolModel = value
  }

  lassoDrawTypeEmit(event){
    if(event == "all"){
      this.MainToolModel ="all_map"
    }else {
      this.MainToolModel = "draw_shape"
    }
  }


  SelectedSubUser
  layerLoader
  @Output()EmitSubLayer  = new EventEmitter<any>()
  AssignMap(value) {

    if(!this.mapid){
      this._isochroneService.openSnackBar("Please create Layer","snackbar-error","fail")
      return
    }

    if(!this.SelectedSubUser){
      this._isochroneService.openSnackBar("Please Select User","snackbar-error","fail")
      return
    }

    let payload
    this.layerLoader = true
    if (this.MainToolModel == 'all_map') {
      payload = {
        "territory_name": this.SelectedSubUser.uname,
        "mapid": this.mapid,
        "userid_forAssign": this.SelectedSubUser.id,
        "style_details": this.SubUsersStyle,
        "bounding_coordinates": "whole_layer",
        // "layerid":this.TerritoryLayerDetails.layerid
        // "view_table": this.tempLayerView,
      }
    }

    else if(this.MainToolModel == 'draw_shape'){
      payload = {
        "territory_name": this.SelectedSubUser.uname,
        "mapid": this.mapid,
        "userid_forAssign": this.SelectedSubUser.id,
        "style_details": this.SubUsersStyle,
        "bounding_coordinates": this.cordinates,
        // "layerid":this.TerritoryLayerDetails.layerid
        // "view_table": this.tempLayerView,
      }
    }

    this.AssignUserService.PostSetUserOnMapSchema(payload).subscribe(result => {
      console.log(result)
      this.layerLoader =false
      if(result.http_code ==200){
       this._isochroneService.openSnackBar("Successfully user set in map layer","snackbar-success","success")
        this._isochroneService.EmitGISSubLayerFn(true)
        // this.draw.deleteAll();
        this.lassoToolsComponent.onResetButton()
        
        let permission

        if(this.SelectedSubUser.role === "EDITOR" || this.SelectedSubUser.role === "BUSINESS_USER"){
          permission = "read_only"
        }else{
          permission ="read_and_write"
        }
        this.SetMapPermission(this.SelectedSubUser.id,permission)


      }
    })
  }


  // View All Users Data
  AllUsersData
  permissionLoader:any = {}
  SetMapPermission(subuser_id,permission){

    this.AssignUserService.ShareMapRestrictionPost(this.mapid,subuser_id,permission).subscribe((res)=>{
      if(res.http_code == 200 && res.data == true){
        this.goToNextStep()
        this.SelectedSubUser =""
        this.getAssignedUsersList()
      }
    })

  }

  getAssignedUsersList(){
    this.AssignUserService.GetAssignUserList(this.mapid).subscribe(res=>{
      if(res.http_code ==200){

        this.AllUsersData = res.data
        console.log(this.AllUsersData)
      }
    })
  }

  UpdateUserRolePermission(pid,permission_mode){
    this.permissionLoader[permission_mode] = true
    // "read_only","read_and_write"
    this.AssignUserService.UpdateUsersRolePermission(pid,permission_mode).subscribe(data=>{
      if(data.http_code == 200 && data.data == true){
        this.permissionLoader[permission_mode] = false
        this._isochroneService.openSnackBar("Permission Update Sucessfully","snackbar-success","success")
        this.getAssignedUsersList()
      }

    })

  }

  goToNextStep(){
    this.matStepStepper = false
    this.stepper.selected.completed = true
    this.stepper.next()
  }



  goToBackStep(){
    this.matStepStepper = true;
    setTimeout(() => {
      this.stepper.previous();
      this.matStepStepper = false;
      this.stepper.selected.completed = false;
    }, 500);
  }

  lastStepRecord
  Addclick(){
    if(this.visible_one && this.stepper ){
      let stepper:any = this.stepper
      this.lastStepRecord = stepper._selectedIndex 
    }else{
      setTimeout(()=>{
        for(let i=0; this.lastStepRecord > i; i++){
          this.stepper.selected.completed = true;
          this.stepper.next(); 
        }
      },100)
    }

    this.AddMore = !this.AddMore; //not equal to condition
    this.visible_one = !this.visible_one
  }



}
